import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    if (typeof (location) == "string") {
        var Separator = "&";
        if (location.indexOf('?') == -1) {
            Separator = '?';
        }
        location = location + Separator;
    }
    return routerPush.call(this, location).catch(error => error)
}
// 路由跳转 携带type 变量 
// type == 3  新增 
// type == 1  编辑 
// type == 4 从其他页面跳转新增 携带参数 例如产品名称 编号 
// type == 5 复制页面 
const router = new Router({
    routes: [{
            path: '/',
            redirect: '/login'
        },
        {
            path: '/',
            component: () => import( /* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: {
                title: '自述文件'
            },
            children: [{
                    path: '/dashboard',
                    name: "dashboard",
                    component: () => import( /* webpackChunkName: "dashboard" */ '../components/page/Dashboard.vue'),
                    meta: {
                        title: '系统首页',
                        keepAlive: false,
                    }
                },
                {
                    path: '/organization',
                    name: "organization",
                    component: () => import( /* webpackChunkName: "organization" */ '../components/page/basicdata/Organization.vue'),
                    meta: {
                        title: '组织架构',
                        keepAlive: false,
                    }
                },
                {
                    path: "/adminList",
                    name: "adminList",
                    component: () => import( /* webpackChunkName: "adminList" */ "../components/page/jurisdiction/admin/AdminList.vue"),
                    meta: {
                        title: '用户管理',
                        keepAlive: false,
                    }
                },
                {
                    path: "/adminDetail",
                    name: "adminDetail",
                    component: () => import( /* webpackChunkName: "adminDetail" */ "../components/page/jurisdiction/admin/AdminDetail.vue"),
                    meta: {
                        title: '用户详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/adminEdit",
                    name: "adminEdit",
                    component: () => import( /* webpackChunkName: "adminEdit" */ "../components/page/jurisdiction/admin/AdminEdit.vue"),
                    meta: {
                        title: '人员',
                        keepAlive: false,
                    }
                },
                {
                    path: "/roleManagement",
                    name: "roleManagement",
                    component: () => import( /* webpackChunkName: "roleManagement" */ "../components/page/jurisdiction/RoleManagement.vue"),
                    meta: {
                        title: '角色管理',
                        keepAlive: false,
                    }
                },
                {
                    path: "/roleField",
                    name: "roleField",
                    component: () => import( /* webpackChunkName: "roleField" */ "../components/page/jurisdiction/RoleField.vue"),
                    meta: {
                        title: '字段权限',
                        keepAlive: false,
                    }
                },
                {
                    path: "/roleRow",
                    name: "roleRow",
                    component: () => import( /* webpackChunkName: "roleRow" */ "../components/page/jurisdiction/RoleRow.vue"),
                    meta: {
                        title: '行级权限',
                        keepAlive: false,
                    }
                },
                {
                    path: "/authoritymanagement",
                    name: "authoritymanagement",
                    component: () => import( /* webpackChunkName: "authoritymanagement" */ "../components/page/jurisdiction/AuthorityManagement.vue"),
                    meta: {
                        title: '权限管理',
                        keepAlive: false,
                    }
                },
                {
                    path: "/hierarchyList",
                    name: "hierarchyList",
                    component: () => import( /* webpackChunkName: "hierarchyList" */ "../components/page/jurisdiction/hierarchy/HierarchyList.vue"),
                    meta: {
                        title: '职位',
                        keepAlive: false,
                    }
                },
                {
                    path: "/hierarchyDetail",
                    name: "hierarchyDetail",
                    component: () => import( /* webpackChunkName: "hierarchyDetail" */ "../components/page/jurisdiction/hierarchy/HierarchyDetail.vue"),
                    meta: {
                        title: '职位详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/hierarchyEdit",
                    name: "hierarchyEdit",
                    component: () => import( /* webpackChunkName: "hierarchyEdit" */ "../components/page/jurisdiction/hierarchy/HierarchyEdit.vue"),
                    meta: {
                        title: '职位',
                        keepAlive: false,
                    }
                },
                {
                    path: "/personList",
                    name: "personList",
                    component: () => import( /* webpackChunkName: "personList" */ "../components/page/jurisdiction/person/PersonList.vue"),
                    meta: {
                        title: '人员',
                        keepAlive: false,
                    }
                },
                {
                    path: "/personDetail",
                    name: "personDetail",
                    component: () => import( /* webpackChunkName: "personDetail" */ "../components/page/jurisdiction/person/PersonDetail.vue"),
                    meta: {
                        title: '人员详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/personEdit",
                    name: "personEdit",
                    component: () => import( /* webpackChunkName: "personEdit" */ "../components/page/jurisdiction/person/PersonEdit.vue"),
                    meta: {
                        title: '人员',
                        keepAlive: false,
                    }
                },
                {
                    path: "/hierarchyPersonList",
                    name: "hierarchyPersonList",
                    component: () => import( /* webpackChunkName: "hierarchyPersonList" */ "../components/page/jurisdiction/hierarchyPerson/HierarchyPersonList.vue"),
                    meta: {
                        title: '任职记录',
                        keepAlive: false,
                    }
                },
                {
                    path: "/hierarchyPersonDetail",
                    name: "hierarchyPersonDetail",
                    component: () => import( /* webpackChunkName: "hierarchyPersonDetail" */ "../components/page/jurisdiction/hierarchyPerson/HierarchyPersonDetail.vue"),
                    meta: {
                        title: '任职记录详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/hierarchyPersonEdit",
                    name: "hierarchyPersonEdit",
                    component: () => import( /* webpackChunkName: "hierarchyPersonEdit" */ "../components/page/jurisdiction/hierarchyPerson/HierarchyPersonEdit.vue"),
                    meta: {
                        title: '任职记录',
                        keepAlive: false,
                    }
                },
                {
                    path: "/departmentList",
                    name: "departmentList",
                    component: () => import( /* webpackChunkName: "departmentList" */ "../components/page/jurisdiction/department/DepartmentList.vue"),
                    meta: {
                        title: '部门',
                        keepAlive: false,
                    }
                },
                {
                    path: "/departmentDetails",
                    name: "departmentDetails",
                    component: () => import( /* webpackChunkName: "departmentDetails" */ "../components/page/jurisdiction/department/DepartmentDetails.vue"),
                    meta: {
                        title: '部门详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/departmentEdit",
                    name: "departmentEdit",
                    component: () => import( /* webpackChunkName: "departmentEdit" */ "../components/page/jurisdiction/department/DepartmentEdit.vue"),
                    meta: {
                        title: '部门',
                        keepAlive: false,
                    }
                },
                {
                    path: "/account",
                    name: "account",
                    component: () => import( /* webpackChunkName: "account" */ "../components/page/basicdata/account/Account.vue"),
                    meta: {
                        title: '账户',
                        keepAlive: false,
                    }
                },
                {
                    path: "/accountDetails",
                    name: "accountDetails",
                    component: () => import( /* webpackChunkName: "accountDetails" */ "../components/page/basicdata/account/AccountDetails.vue"),
                    meta: {
                        title: '账户详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/accountEdit",
                    name: "accountEdit",
                    component: () => import( /* webpackChunkName: "accountEdit" */ "../components/page/basicdata/account/AccountEdit.vue"),
                    meta: {
                        title: '账户',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/accountMergeList",
                    name: "accountMergeList",
                    component: () => import( /* webpackChunkName: "accountMergeList" */ "../components/page/basicdata/account/AccountMergeList.vue"),
                    meta: {
                        title: '账户合并列表',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/flowSourceLists",
                    name: "flowSourceLists",
                    component: () => import( /* webpackChunkName: "flowSourceLists" */ "../components/page/basicdata/flowsource/FlowSourceLists.vue"),
                    meta: {
                        title: '流向',
                        keepAlive: false,
                    }
                },
                {
                    path: "/commodityFlowDetail",
                    name: "commodityFlowDetail",
                    component: () => import( /* webpackChunkName: "commodityFlowDetail" */ "../components/page/basicdata/flowsource/CommodityFlowDetail.vue"),
                    meta: {
                        title: '流向详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/commodityFlowEdit",
                    name: "commodityFlowEdit",
                    component: () => import( /* webpackChunkName: "commodityFlowEdit" */ "../components/page/basicdata/flowsource/CommodityFlowEdit.vue"),
                    meta: {
                        title: '流向',
                        keepAlive: false,
                    }
                },
                {
                    path: "/bankAccount",
                    name: "bankAccount",
                    component: () => import( /* webpackChunkName: "bankAccount" */ "../components/page/basicdata/bankAccount/BankAccountList.vue"),
                    meta: {
                        title: '银行账户',
                        keepAlive: false,
                    }
                },
                {
                    path: "/bankAccountDetail",
                    name: "bankAccountDetail",
                    component: () => import( /* webpackChunkName: "bankAccountDetail" */ "../components/page/basicdata/bankAccount/BankAccountDetail.vue"),
                    meta: {
                        title: '银行账户详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/bankAccountEdit",
                    name: "bankAccountEdit",
                    component: () => import( /* webpackChunkName: "bankAccountEdit" */ "../components/page/basicdata/bankAccount/BankAccountEdit.vue"),
                    meta: {
                        title: '银行账户',
                        keepAlive: false,
                    }
                },
                {
                    path: "/flowProductList",
                    name: "flowProductList",
                    component: () => import( /* webpackChunkName: "flowProductList" */ "../components/page/basicdata/flowsource/FlowProductList.vue"),
                    meta: {
                        title: '关联产品列表',
                        keepAlive: false,
                    }
                },
                {
                    path: "/flowSupplierList",
                    name: "flowSupplierList",
                    component: () => import( /* webpackChunkName: "flowSupplierList" */ "../components/page/basicdata/flowsource/FlowSupplierList.vue"),
                    meta: {
                        title: '关联供方列表',
                        keepAlive: false,
                    }
                },
                {
                    path: "/flowDemanderList",
                    name: "flowDemanderList",
                    component: () => import( /* webpackChunkName: "flowDemanderList" */ "../components/page/basicdata/flowsource/FlowDemanderList.vue"),
                    meta: {
                        title: '关联需方列表',
                        keepAlive: false,
                    }
                },
                {
                    path: "/flowNegativeList",
                    name: "flowNegativeList",
                    component: () => import( /* webpackChunkName: "flowNegativeList" */ "../components/page/basicdata/flowsource/FlowNegativeList.vue"),
                    meta: {
                        title: '冲销负流向',
                        keepAlive: false,
                    }
                },
                {
                    path: "/flowNegativeWriteoffList",
                    name: "flowNegativeWriteoffList",
                    component: () => import( /* webpackChunkName: "flowNegativeWriteoffList" */ "../components/page/basicdata/flowsource/FlowNegativeWriteoffList.vue"),
                    meta: {
                        title: '负流向已冲销',
                        keepAlive: false,
                    }
                },
                {
                    path: "/repertoryList",
                    name: "repertoryList",
                    component: () => import( /* webpackChunkName: "repertoryList" */ "../components/page/basicdata/flowsource/RepertoryList.vue"),
                    meta: {
                        title: '库存',
                        keepAlive: false,
                    }
                },
                {
                    path: "/repertoryDetail",
                    name: "repertoryDetail",
                    component: () => import( /* webpackChunkName: "repertoryDetail" */ "../components/page/basicdata/flowsource/RepertoryDetail.vue"),
                    meta: {
                        title: '库存详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/repertoryEdit",
                    name: "repertoryEdit",
                    component: () => import( /* webpackChunkName: "repertoryEdit" */ "../components/page/basicdata/flowsource/RepertoryEdit.vue"),
                    meta: {
                        title: '库存',
                        keepAlive: false,
                    }
                },
                {
                    path: "/repertoryPrincipalList",
                    name: "repertoryPrincipalList",
                    component: () => import( /* webpackChunkName: "repertoryPrincipalList" */ "../components/page/basicdata/flowsource/RepertoryPrincipalList.vue"),
                    meta: {
                        title: '我负责的',
                        keepAlive: false,
                    }
                },
                {
                    path: "/stockProductList",
                    name: "stockProductList",
                    component: () => import( /* webpackChunkName: "stockProductList" */ "../components/page/basicdata/flowsource/StockProductList.vue"),
                    meta: {
                        title: '关联产品列表',
                        keepAlive: false,
                    }
                },
                {
                    path: "/stockOwnerList",
                    name: "stockOwnerList",
                    component: () => import( /* webpackChunkName: "stockOwnerList" */ "../components/page/basicdata/flowsource/StockOwnerList.vue"),
                    meta: {
                        title: '关联产品所有者列表',
                        keepAlive: false,
                    }
                },
                {
                    path: "/flowVoucherList",
                    name: "flowVoucherList",
                    component: () => import( /* webpackChunkName: "flowVoucherList" */ "../components/page/basicdata/flowVoucher/FlowVoucherList.vue"),
                    meta: {
                        title: '流向凭据',
                        keepAlive: false,
                    }
                },

                {
                    path: "/flowVoucherDetail",
                    name: "flowVoucherDetail",
                    component: () => import( /* webpackChunkName: "flowVoucherDetail" */ "../components/page/basicdata/flowVoucher/FlowVoucherDetail.vue"),
                    meta: {
                        title: '流向凭据详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/flowVoucherEdit",
                    name: "flowVoucherEdit",
                    component: () => import( /* webpackChunkName: "flowVoucherEdit" */ "../components/page/basicdata/flowVoucher/FlowVoucherEdit.vue"),
                    meta: {
                        title: '流向凭据',
                        keepAlive: false,
                    }
                },
                {
                    path: "/flowSourceConfigList",
                    name: "flowSourceConfigList",
                    component: () => import( /* webpackChunkName: "flowSourceConfigLists" */ "../components/page/basicdata/flowSourceConfig/FlowSourceConfigList.vue"),
                    meta: {
                        title: '流向凭据配置',
                        keepAlive: false,
                    }
                },
                {
                    path: "/flowSourceConfigDetail",
                    name: "flowSourceConfigDetail",
                    component: () => import( /* webpackChunkName: "flowSourceConfigDetail" */ "../components/page/basicdata/flowSourceConfig/FlowSourceConfigDetail.vue"),
                    meta: {
                        title: '流向凭据配置详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/flowSourceConfigEdit",
                    name: "flowSourceConfigEdit",
                    component: () => import( /* webpackChunkName: "flowSourceConfigEdit" */ "../components/page/basicdata/flowSourceConfig/FlowSourceConfigEdit.vue"),
                    meta: {
                        title: '流向凭据配置',
                        keepAlive: false,
                    }
                },
                {
                    path: "/gantt",
                    name: "gantt",
                    component: () => import( /* webpackChunkName: "accountEdit" */ "../components/page/gantt.vue"),
                    meta: {
                        title: '甘特图',
                        keepAlive: false,
                    }
                },
                {
                    path: "/province",
                    name: "province",
                    component: () => import( /* webpackChunkName: "province" */ "../components/page/basicdata/province/Province.vue"),
                    meta: {
                        title: '省市区数据',
                        keepAlive: false,
                    }
                },
                {
                    path: "/productapproval",
                    name: "productapproval",
                    component: () => import( /* webpackChunkName: "productapproval" */ "../components/page/basicdata/approval/ProductApproval.vue"),
                    meta: {
                        title: '产品批文',
                        keepAlive: false,
                    }
                },
                {
                    path: "/productdetails",
                    name: "productdetails",
                    component: () => import( /* webpackChunkName: "productdetails" */ "../components/page/basicdata/approval/ProductDetails.vue"),
                    meta: {
                        title: '产品批文详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/productedit",
                    name: "productedit",
                    component: () => import( /* webpackChunkName: "productedit" */ "../components/page/basicdata/approval/ProductEdit.vue"),
                    meta: {
                        title: '产品批文',
                        keepAlive: false,
                    }
                },
                {
                    path: "/productList",
                    name: "productList",
                    component: () => import( /* webpackChunkName: "productList" */ "../components/page/basicdata/product/ProductList.vue"),
                    meta: {
                        title: '产品',
                        keepAlive: false,
                    }
                },
                {
                    path: "/productListDetails",
                    name: "productListDetails",
                    component: () => import( /* webpackChunkName: "productListDetails" */ "../components/page/basicdata/product/ProductListDetails.vue"),
                    meta: {
                        title: '产品详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/productListEdit",
                    name: "productListEdit",
                    component: () => import( /* webpackChunkName: "productListEdit" */ "../components/page/basicdata/product/ProductListEdit.vue"),
                    meta: {
                        title: '产品',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/productPeriodList",
                    name: "productPeriodList",
                    component: () => import( /* webpackChunkName: "productPeriodList" */ "../components/page/basicdata/product/ProductPeriodList.vue"),
                    meta: {
                        title: '产品期间',
                        keepAlive: false,
                    }
                },
                {
                    path: "/productPeriodDetail",
                    name: "productPeriodDetail",
                    component: () => import( /* webpackChunkName: "productPeriodDetails" */ "../components/page/basicdata/product/ProductPeriodDetail.vue"),
                    meta: {
                        title: '产品期间详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/productPeriodEdit",
                    name: "productPeriodEdit",
                    component: () => import( /* webpackChunkName: "productPeriodEdit" */ "../components/page/basicdata/product/ProductPeriodEdit.vue"),
                    meta: {
                        title: '产品期间',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/productLicencePeriodList",
                    name: "productLicencePeriodList",
                    component: () => import( /* webpackChunkName: "productLicencePeriodList" */ "../components/page/basicdata/product/ProductLicencePeriodList.vue"),
                    meta: {
                        title: '产品批文期间',
                        keepAlive: false,
                    }
                },
                {
                    path: "/productLicencePeriodDetail",
                    name: "productLicencePeriodDetail",
                    component: () => import( /* webpackChunkName: "productLicencePeriodDetails" */ "../components/page/basicdata/product/ProductLicencePeriodDetail.vue"),
                    meta: {
                        title: '产品批文期间详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/productLicencePeriodEdit",
                    name: "productLicencePeriodEdit",
                    component: () => import( /* webpackChunkName: "productLicencePeriodEdit" */ "../components/page/basicdata/product/ProductLicencePeriodEdit.vue"),
                    meta: {
                        title: '产品批文期间',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/productUnitList",
                    name: "productUnitList",
                    component: () => import( /* webpackChunkName: "productUnitList" */ "../components/page/basicdata/product/ProductUnitList.vue"),
                    meta: {
                        title: '产品单位',
                        keepAlive: false,
                    }
                },
                {
                    path: "/productUnitDetail",
                    name: "productUnitDetail",
                    component: () => import( /* webpackChunkName: "productUnitDetail" */ "../components/page/basicdata/product/ProductUnitDetail.vue"),
                    meta: {
                        title: '产品单位详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/productUnitEdit",
                    name: "productUnitEdit",
                    component: () => import( /* webpackChunkName: "productUnitEdit" */ "../components/page/basicdata/product/ProductUnitEdit.vue"),
                    meta: {
                        title: '产品单位',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerList",
                    name: "partnerList",
                    component: () => import( /* webpackChunkName: "partnerList" */ "../components/page/basicdata/partner/PartnerList.vue"),
                    meta: {
                        title: '合作方',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerDetails",
                    name: "partnerDetails",
                    component: () => import( /* webpackChunkName: "partnerDetails" */ "../components/page/basicdata/partner/PartnerDetails.vue"),
                    meta: {
                        title: '合作方详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerEdit",
                    name: "partnerEdit",
                    component: () => import( /* webpackChunkName: "partnerEdit" */ "../components/page/basicdata/partner/PartnerEdit.vue"),
                    meta: {
                        title: '合作方',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerCurrentList",
                    name: "partnerCurrentList",
                    component: () => import( /* webpackChunkName: "partnerCurrentList" */ "../components/page/basicdata/partnerCurrent/PartnerCurrentList.vue"),
                    meta: {
                        title: '合作往来',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerCurrentDetail",
                    name: "partnerCurrentDetail",
                    component: () => import( /* webpackChunkName: "partnerCurrentDetail" */ "../components/page/basicdata/partnerCurrent/PartnerCurrentDetail.vue"),
                    meta: {
                        title: '合作往来详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerCurrentEdit",
                    name: "partnerCurrentEdit",
                    component: () => import( /* webpackChunkName: "partnerCurrentEdit" */ "../components/page/basicdata/partnerCurrent/PartnerCurrentEdit.vue"),
                    meta: {
                        title: '合作往来',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerCurrentLineList",
                    name: "partnerCurrentLineList",
                    component: () => import( /* webpackChunkName: "partnerCurrentLineList" */ "../components/page/basicdata/partnerCurrentLine/PartnerCurrentLineList.vue"),
                    meta: {
                        title: '合作往来行',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerCurrentLineDetail",
                    name: "partnerCurrentLineDetail",
                    component: () => import( /* webpackChunkName: "partnerCurrentLineDetail" */ "../components/page/basicdata/partnerCurrentLine/PartnerCurrentLineDetail.vue"),
                    meta: {
                        title: '合作往来行详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerCurrentLineEdit",
                    name: "partnerCurrentLineEdit",
                    component: () => import( /* webpackChunkName: "partnerCurrentLineEdit" */ "../components/page/basicdata/partnerCurrentLine/PartnerCurrentLineEdit.vue"),
                    meta: {
                        title: '合作往来行',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerCurrentWithholdList",
                    name: "partnerCurrentWithholdList",
                    component: () => import( /* webpackChunkName: "partnerCurrentWithholdList" */ "../components/page/basicdata/partnerCurrentWithhold/PartnerCurrentWithholdList.vue"),
                    meta: {
                        title: '合作往来保留',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerCurrentWithholdEdit",
                    name: "partnerCurrentWithholdEdit",
                    component: () => import( /* webpackChunkName: "partnerCurrentWithholdEdit" */ "../components/page/basicdata/partnerCurrentWithhold/PartnerCurrentWithholdEdit.vue"),
                    meta: {
                        title: '合作往来保留',
                        keepAlive: false,
                    }
                },
                {
                    path: "/contactList",
                    name: "contactList",
                    component: () => import( /* webpackChunkName: "contactList" */ "../components/page/basicdata/contact/ContactList.vue"),
                    meta: {
                        title: '联系人',
                        keepAlive: false,
                    }
                },
                {
                    path: "/contactDetail",
                    name: "contactDetail",
                    component: () => import( /* webpackChunkName: "contactDetail" */ "../components/page/basicdata/contact/ContactDetail.vue"),
                    meta: {
                        title: '联系人详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/contactEdit",
                    name: "contactEdit",
                    component: () => import( /* webpackChunkName: "contactEdit" */ "../components/page/basicdata/contact/ContactEdit.vue"),
                    meta: {
                        title: '联系人',
                        keepAlive: false,
                    }
                },
                {
                    path: "/parameterList",
                    name: "parameterList",
                    component: () => import( /* webpackChunkName: "parameterList" */ "../components/page/basicdata/parameter/ParameterList.vue"),
                    meta: {
                        title: '参数',
                        keepAlive: false,
                    }
                },
                {
                    path: "/parameterDetail",
                    name: "parameterDetail",
                    component: () => import( /* webpackChunkName: "parameterDetail" */ "../components/page/basicdata/parameter/ParameterDetail.vue"),
                    meta: {
                        title: '参数详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/parameterEdit",
                    name: "parameterEdit",
                    component: () => import( /* webpackChunkName: "parameterEdit" */ "../components/page/basicdata/parameter/ParameterEdit.vue"),
                    meta: {
                        title: '参数',
                        keepAlive: false,
                    }
                },
                {
                    path: "/viewManagerList",
                    name: "viewManagerList",
                    component: () => import( /* webpackChunkName: "viewManagerList" */ "../components/page/basicdata/viewManager/ViewManagerList.vue"),
                    meta: {
                        title: '视图管理',
                        keepAlive: false,
                    }
                },
                {
                    path: "/materialList",
                    name: "materialList",
                    component: () => import( /* webpackChunkName: "materialList" */ "../components/page/basicdata/material/MaterialList.vue"),
                    meta: {
                        title: '物料',
                        keepAlive: false,
                    }
                },
                {
                    path: "/materialDetail",
                    name: "materialDetail",
                    component: () => import( /* webpackChunkName: "materialDetail" */ "../components/page/basicdata/material/MaterialDetail.vue"),
                    meta: {
                        title: '物料详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/materialEdit",
                    name: "materialEdit",
                    component: () => import( /* webpackChunkName: "materialEdit" */ "../components/page/basicdata/material/MaterialEdit.vue"),
                    meta: {
                        title: '物料',
                        keepAlive: false,
                    }
                },
                {
                    path: "/materialSourceList",
                    name: "materialSourceList",
                    component: () => import( /* webpackChunkName: "materialSourceList" */ "../components/page/basicdata/materialSource/MaterialSourceList.vue"),
                    meta: {
                        title: '物料源',
                        keepAlive: false,
                    }
                },
                {
                    path: "/materialSourceDetail",
                    name: "materialSourceDetail",
                    component: () => import( /* webpackChunkName: "materialSourceDetail" */ "../components/page/basicdata/materialSource/MaterialSourceDetail.vue"),
                    meta: {
                        title: '物料源详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/materialSourceEdit",
                    name: "materialSourceEdit",
                    component: () => import( /* webpackChunkName: "materialSourceEdit" */ "../components/page/basicdata/materialSource/MaterialSourceEdit.vue"),
                    meta: {
                        title: '物料源',
                        keepAlive: false,
                    }
                },
                {
                    path: "/materialTypeList",
                    name: "materialTypeList",
                    component: () => import( /* webpackChunkName: "materialTypeList" */ "../components/page/basicdata/materialType/MaterialTypeList.vue"),
                    meta: {
                        title: '物料类型',
                        keepAlive: false,
                    }
                },
                {
                    path: "/materialTypeDetail",
                    name: "materialTypeDetail",
                    component: () => import( /* webpackChunkName: "materialTypeDetail" */ "../components/page/basicdata/materialType/MaterialTypeDetail.vue"),
                    meta: {
                        title: '物料类型详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/materialTypeEdit",
                    name: "materialTypeEdit",
                    component: () => import( /* webpackChunkName: "materialTypeEdit" */ "../components/page/basicdata/materialType/MaterialTypeEdit.vue"),
                    meta: {
                        title: '物料类型',
                        keepAlive: false,
                    }
                },
                {
                    path: "/priceControlList",
                    name: "priceControlList",
                    component: () => import( /* webpackChunkName: "priceControlList" */ "../components/page/riskcontrol/pricecontrol/PriceControlList.vue"),
                    meta: {
                        title: '价格控制',
                        keepAlive: false,
                    }
                },
                {
                    path: "/priceControlDetail",
                    name: "priceControlDetail",
                    component: () => import( /* webpackChunkName: "priceControlDetail" */ "../components/page/riskcontrol/pricecontrol/PriceControlDetail.vue"),
                    meta: {
                        title: '价格控制详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/priceControlEdit",
                    name: "priceControlEdit",
                    component: () => import( /* webpackChunkName: "priceControlEdit" */ "../components/page/riskcontrol/pricecontrol/PriceControlEdit.vue"),
                    meta: {
                        title: '价格控制',
                        keepAlive: false,
                    }
                },
                {
                    path: "/cooperationList",
                    name: "cooperationList",
                    component: () => import( /* webpackChunkName: "cooperationList" */ "../components/page/riskcontrol/cooperation/CooperationList.vue"),
                    meta: {
                        title: '合作规划',
                        keepAlive: false,
                    }
                },
                {
                    path: "/cooperationDetail",
                    name: "cooperationDetail",
                    component: () => import( /* webpackChunkName: "cooperationDetail" */ "../components/page/riskcontrol/cooperation/CooperationDetail.vue"),
                    meta: {
                        title: '合作规划详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/cooperationEdit",
                    name: "cooperationEdit",
                    component: () => import( /* webpackChunkName: "cooperationEdit" */ "../components/page/riskcontrol/cooperation/CooperationEdit.vue"),
                    meta: {
                        title: '合作规划',
                        keepAlive: false,
                    }
                },
                {
                    path: "/cooperativePriceList",
                    name: "cooperativePriceList",
                    component: () => import( /* webpackChunkName: "cooperativePriceList" */ "../components/page/riskcontrol/cooperativeprice/CooperativePriceList.vue"),
                    meta: {
                        title: '合作价格',
                        keepAlive: false,
                    }
                },
                {
                    path: "/cooperativePriceDetail",
                    name: "cooperativePriceDetail",
                    component: () => import( /* webpackChunkName: "cooperativePriceDetail" */ "../components/page/riskcontrol/cooperativeprice/CooperativePriceDetail.vue"),
                    meta: {
                        title: '合作价格详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/cooperativePriceEdit",
                    name: "cooperativePriceEdit",
                    component: () => import( /* webpackChunkName: "cooperativePriceEdit" */ "../components/page/riskcontrol/cooperativeprice/CooperativePriceEdit.vue"),
                    meta: {
                        title: '合作价格',
                        keepAlive: false,
                    }
                },
                {
                    path: "/orderList",
                    name: "orderList",
                    component: () => import( /* webpackChunkName: "orderList" */ "../components/page/orderManage/order/OrderList.vue"),
                    meta: {
                        title: '订单',
                        keepAlive: false,
                    }
                },
                {
                    path: "/orderDetail",
                    name: "orderDetail",
                    component: () => import( /* webpackChunkName: "orderDetail" */ "../components/page/orderManage/order/OrderDetail.vue"),
                    meta: {
                        title: '订单详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/orderEdit",
                    name: "orderEdit",
                    component: () => import( /* webpackChunkName: "orderEdit" */ "../components/page/orderManage/order/OrderEdit.vue"),
                    meta: {
                        title: '订单',
                        keepAlive: false,
                    }
                },
                {
                    path: "/orderLineList",
                    name: "orderLineList",
                    component: () => import( /* webpackChunkName: "orderLineList" */ "../components/page/orderManage/orderLine/OrderLineList.vue"),
                    meta: {
                        title: '订单行',
                        keepAlive: false,
                    }
                },
                {
                    path: "/orderLineDetail",
                    name: "orderLineDetail",
                    component: () => import( /* webpackChunkName: "orderLineDetail" */ "../components/page/orderManage/orderLine/OrderLineDetail.vue"),
                    meta: {
                        title: '订单行详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/orderParticularsList",
                    name: "orderParticularsList",
                    component: () => import( /* webpackChunkName: "orderParticularsList" */ "../components/page/orderManage/orderDetails/OrderParticularsList.vue"),
                    meta: {
                        title: '订单明细',
                        keepAlive: false,
                    }
                },
                {
                    path: "/orderParticulars",
                    name: "orderParticulars",
                    component: () => import( /* webpackChunkName: "orderParticulars" */ "../components/page/orderManage/orderDetails/OrderParticulars.vue"),
                    meta: {
                        title: '订单明细详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/tradeLineList",
                    name: "tradeLineList",
                    component: () => import( /* webpackChunkName: "tradeLineList" */ "../components/page/orderManage/tradeLine/TradeLineList.vue"),
                    meta: {
                        title: '交易行',
                        keepAlive: false,
                    }
                },
                {
                    path: "/tradeLineDetails",
                    name: "tradeLineDetails",
                    component: () => import( /* webpackChunkName: "tradeLineDetails" */ "../components/page/orderManage/tradeLine/TradeLineDetails.vue"),
                    meta: {
                        title: '交易行详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/dealDetailList",
                    name: "dealDetailList",
                    component: () => import( /* webpackChunkName: "dealDetailList" */ "../components/page/orderManage/dealDetail/DealDetailList.vue"),
                    meta: {
                        title: '交易明细',
                        keepAlive: false,
                    }
                },
                {
                    path: "/dealDetailDetail",
                    name: "dealDetailDetail",
                    component: () => import( /* webpackChunkName: "dealDetailDetail" */ "../components/page/orderManage/dealDetail/DealDetailDetail.vue"),
                    meta: {
                        title: '交易明细详情',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/transactionList",
                    name: "transactionList",
                    component: () => import( /* webpackChunkName: "transactionList" */ "../components/page/basicdata/transaction/TransactionList.vue"),
                    meta: {
                        title: '业务',
                        keepAlive: false,
                    }
                },
                {
                    path: "/transactionDetail",
                    name: "transactionDetail",
                    component: () => import( /* webpackChunkName: "transactionDetail" */ "../components/page/basicdata/transaction/TransactionDetail.vue"),
                    meta: {
                        title: '业务详情',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/transactionAttachmentList",
                    name: "transactionAttachmentList",
                    component: () => import( /* webpackChunkName: "transactionAttachmentList" */ "../components/page/basicdata/transactionAttachment/TransactionAttachmentList.vue"),
                    meta: {
                        title: '业务附件',
                        keepAlive: false,
                    }
                },
                {
                    path: "/transactionAttachmentDetail",
                    name: "transactionAttachmentDetail",
                    component: () => import( /* webpackChunkName: "transactionAttachmentDetail" */ "../components/page/basicdata/transactionAttachment/TransactionAttachmentDetail.vue"),
                    meta: {
                        title: '业务附件详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/transactionAttachmentEdit",
                    name: "transactionAttachmentEdit",
                    component: () => import( /* webpackChunkName: "transactionAttachmentEdit" */ "../components/page/basicdata/transactionAttachment/TransactionAttachmentEdit.vue"),
                    meta: {
                        title: '业务附件',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/transactionLogisticsList",
                    name: "transactionLogisticsList",
                    component: () => import( /* webpackChunkName: "transactionLogisticsList" */ "../components/page/basicdata/transactionLogistics/TransactionLogisticsList.vue"),
                    meta: {
                        title: '物流跟踪',
                        keepAlive: false,
                    }
                },
                {
                    path: "/transactionLogisticsDetail",
                    name: "transactionLogisticsDetail",
                    component: () => import( /* webpackChunkName: "transactionLogisticsDetail" */ "../components/page/basicdata/transactionLogistics/TransactionLogisticsDetail.vue"),
                    meta: {
                        title: '物流跟踪详情',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/receivableList",
                    name: "receivableList",
                    component: () => import( /* webpackChunkName: "receivableList" */ "../components/page/basicdata/receivable/ReceivableList.vue"),
                    meta: {
                        title: '应收',
                        keepAlive: false,
                    }
                },
                {
                    path: "/receivableDetail",
                    name: "receivableDetail",
                    component: () => import( /* webpackChunkName: "receivableDetail" */ "../components/page/basicdata/receivable/ReceivableDetail.vue"),
                    meta: {
                        title: '应收详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/receivableEdit",
                    name: "receivableEdit",
                    component: () => import( /* webpackChunkName: "receivableEdit" */ "../components/page/basicdata/receivable/ReceivableEdit.vue"),
                    meta: {
                        title: '应收',
                        keepAlive: false,
                    }
                },
                {
                    path: "/receivableAdjustmentList",
                    name: "receivableAdjustmentList",
                    component: () => import( /* webpackChunkName: "receivableAdjustmentList" */ "../components/page/basicdata/receivableAdjustment/ReceivableAdjustmentList.vue"),
                    meta: {
                        title: '应收调整',
                        keepAlive: false,
                    }
                },
                {
                    path: "/receivableAdjustmentDetail",
                    name: "receivableAdjustmentDetail",
                    component: () => import( /* webpackChunkName: "receivableAdjustmentDetail" */ "../components/page/basicdata/receivableAdjustment/ReceivableAdjustmentDetail.vue"),
                    meta: {
                        title: '应收调整详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/receivableAdjustmentEdit",
                    name: "receivableAdjustmentEdit",
                    component: () => import( /* webpackChunkName: "receivableAdjustmentEdit" */ "../components/page/basicdata/receivableAdjustment/ReceivableAdjustmentEdit.vue"),
                    meta: {
                        title: '应收调整',
                        keepAlive: false,
                    }
                },
                {
                    path: "/receivableAdjustmentLineList",
                    name: "receivableAdjustmentLineList",
                    component: () => import( /* webpackChunkName: "receivableAdjustmentLineList" */ "../components/page/basicdata/receivableAdjustmentLine/ReceivableAdjustmentLineList.vue"),
                    meta: {
                        title: '应收调整行',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/commodityFlowAdjustmentList",
                    name: "commodityFlowAdjustmentList",
                    component: () => import( /* webpackChunkName: "commodityFlowAdjustmentList" */ "../components/page/basicdata/commodityFlowAdjustment/CommodityFlowAdjustmentList.vue"),
                    meta: {
                        title: '流向调整',
                        keepAlive: false,
                    }
                },
                {
                    path: "/commodityFlowAdjustmentDetail",
                    name: "commodityFlowAdjustmentDetail",
                    component: () => import( /* webpackChunkName: "commodityFlowAdjustmentDetail" */ "../components/page/basicdata/commodityFlowAdjustment/CommodityFlowAdjustmentDetail.vue"),
                    meta: {
                        title: '流向调整详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/commodityFlowAdjustmentEdit",
                    name: "commodityFlowAdjustmentEdit",
                    component: () => import( /* webpackChunkName: "commodityFlowAdjustmentEdit" */ "../components/page/basicdata/commodityFlowAdjustment/CommodityFlowAdjustmentEdit.vue"),
                    meta: {
                        title: '流向调整',
                        keepAlive: false,
                    }
                },
                {
                    path: "/commodityFlowAdjustmentLineList",
                    name: "commodityFlowAdjustmentLineList",
                    component: () => import( /* webpackChunkName: "commodityFlowAdjustmentLineList" */ "../components/page/basicdata/commodityFlowAdjustmentLine/CommodityFlowAdjustmentLineList.vue"),
                    meta: {
                        title: '流向调整行',
                        keepAlive: false,
                    }
                },
                {
                    path: "/receiptList",
                    name: "receiptList",
                    component: () => import( /* webpackChunkName: "receiptList" */ "../components/page/basicdata/performance/ReceiptList.vue"),
                    meta: {
                        title: '收款单',
                        keepAlive: false,
                    }
                },
                {
                    path: "/receiptDetail",
                    name: "receiptDetail",
                    component: () => import( /* webpackChunkName: "receiptDetail" */ "../components/page/basicdata/performance/ReceiptDetail.vue"),
                    meta: {
                        title: '收款单详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/receiptEdit",
                    name: "receiptEdit",
                    component: () => import( /* webpackChunkName: "receiptEdit" */ "../components/page/basicdata/performance/ReceiptEdit.vue"),
                    meta: {
                        title: '收款单',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performanceAssignmentList",
                    name: "performanceAssignmentList",
                    component: () => import( /* webpackChunkName: "performanceAssignmentList" */ "../components/page/basicdata/performance/PerformanceAssignmentList.vue"),
                    meta: {
                        title: '绩效分配',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performanceAssignmentDetail",
                    name: "performanceAssignmentDetail",
                    component: () => import( /* webpackChunkName: "performanceAssignmentDetail" */ "../components/page/basicdata/performance/PerformanceAssignmentDetail.vue"),
                    meta: {
                        title: '绩效分配详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performanceAssignmentEdit",
                    name: "performanceAssignmentEdit",
                    component: () => import( /* webpackChunkName: "performanceAssignmentEdit" */ "../components/page/basicdata/performance/PerformanceAssignmentEdit.vue"),
                    meta: {
                        title: '绩效分配',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performanceAssignmentLineList",
                    name: "performanceAssignmentLineList",
                    component: () => import( /* webpackChunkName: "performanceAssignmentLineList" */ "../components/page/basicdata/performance/PerformanceAssignmentLineList.vue"),
                    meta: {
                        title: '绩效分配行',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performanceUnitList",
                    name: "performanceUnitList",
                    component: () => import( /* webpackChunkName: "performanceUnitList" */ "../components/page/basicdata/performance/PerformanceUnitList.vue"),
                    meta: {
                        title: '绩效单元',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performanceUnitDetail",
                    name: "performanceUnitDetail",
                    component: () => import( /* webpackChunkName: "performanceUnitDetail" */ "../components/page/basicdata/performance/PerformanceUnitDetail.vue"),
                    meta: {
                        title: '绩效单元详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performanceUnitEdit",
                    name: "performanceUnitEdit",
                    component: () => import( /* webpackChunkName: "performanceUnitEdit" */ "../components/page/basicdata/performance/PerformanceUnitEdit.vue"),
                    meta: {
                        title: '绩效单元',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/performanceUnitSnapshotList",
                    name: "performanceUnitSnapshotList",
                    component: () => import( /* webpackChunkName: "performanceUnitSnapshotList" */ "../components/page/basicdata/performance/PerformanceUnitSnapshotList.vue"),
                    meta: {
                        title: '绩效单元快照',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performanceUnitSnapshotDetail",
                    name: "performanceUnitSnapshotDetail",
                    component: () => import( /* webpackChunkName: "performanceUnitSnapshotDetail" */ "../components/page/basicdata/performance/PerformanceUnitSnapshotDetail.vue"),
                    meta: {
                        title: '绩效单元快照详情',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/performancePersonConfigList",
                    name: "performancePersonConfigList",
                    component: () => import( /* webpackChunkName: "performancePersonConfigList" */ "../components/page/basicdata/performance/PerformancePersonConfigList.vue"),
                    meta: {
                        title: '绩效人员配置',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performancePersonConfigDetail",
                    name: "performancePersonConfigDetail",
                    component: () => import( /* webpackChunkName: "performancePersonConfigDetail" */ "../components/page/basicdata/performance/PerformancePersonConfigDetail.vue"),
                    meta: {
                        title: '绩效人员配置详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performancePersonConfigEdit",
                    name: "performancePersonConfigEdit",
                    component: () => import( /* webpackChunkName: "performancePersonConfigEdit" */ "../components/page/basicdata/performance/PerformancePersonConfigEdit.vue"),
                    meta: {
                        title: '绩效人员配置',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/performancePersonList",
                    name: "performancePersonList",
                    component: () => import( /* webpackChunkName: "performancePersonList" */ "../components/page/basicdata/performance/PerformancePersonList.vue"),
                    meta: {
                        title: '绩效人员',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performancePersonDetail",
                    name: "performancePersonDetail",
                    component: () => import( /* webpackChunkName: "performancePersonDetail" */ "../components/page/basicdata/performance/PerformancePersonDetail.vue"),
                    meta: {
                        title: '绩效人员详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performancePersonEdit",
                    name: "performancePersonEdit",
                    component: () => import( /* webpackChunkName: "performancePersonEdit" */ "../components/page/basicdata/performance/PerformancePersonEdit.vue"),
                    meta: {
                        title: '绩效人员',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/performancePersonSnapshotList",
                    name: "performancePersonSnapshotList",
                    component: () => import( /* webpackChunkName: "performancePersonSnapshotList" */ "../components/page/basicdata/performance/PerformancePersonSnapshotList.vue"),
                    meta: {
                        title: '绩效人员快照',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performancePersonSnapshotDetail",
                    name: "performancePersonSnapshotDetail",
                    component: () => import( /* webpackChunkName: "performancePersonSnapshotDetail" */ "../components/page/basicdata/performance/PerformancePersonSnapshotDetail.vue"),
                    meta: {
                        title: '绩效人员快照详情',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/performanceProductList",
                    name: "performanceProductList",
                    component: () => import( /* webpackChunkName: "performanceProductList" */ "../components/page/basicdata/performance/PerformanceProductList.vue"),
                    meta: {
                        title: '绩效产品',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performanceProductDetail",
                    name: "performanceProductDetail",
                    component: () => import( /* webpackChunkName: "performanceProductDetail" */ "../components/page/basicdata/performance/PerformanceProductDetail.vue"),
                    meta: {
                        title: '绩效产品详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performanceProductEdit",
                    name: "performanceProductEdit",
                    component: () => import( /* webpackChunkName: "performanceProductEdit" */ "../components/page/basicdata/performance/PerformanceProductEdit.vue"),
                    meta: {
                        title: '绩效产品',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performanceProductLineList",
                    name: "performanceProductLineList",
                    component: () => import( /* webpackChunkName: "performanceProductLineList" */ "../components/page/basicdata/performance/PerformanceProductLineList.vue"),
                    meta: {
                        title: '绩效产品行',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performanceProductLineDetail",
                    name: "performanceProductLineDetail",
                    component: () => import( /* webpackChunkName: "performanceProductLineDetail" */ "../components/page/basicdata/performance/PerformanceProductLineDetail.vue"),
                    meta: {
                        title: '绩效产品行详情',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/consumptionLineList",
                    name: "consumptionLineList",
                    component: () => import( /* webpackChunkName: "consumptionLineList" */ "../components/page/basicdata/performance/ConsumptionLineList.vue"),
                    meta: {
                        title: '消化行',
                        keepAlive: false,
                    }
                },
                {
                    path: "/consumptionLineDetail",
                    name: "consumptionLineDetail",
                    component: () => import( /* webpackChunkName: "consumptionLineDetail" */ "../components/page/basicdata/performance/ConsumptionLineDetail.vue"),
                    meta: {
                        title: '消化行详情',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/consumptionList",
                    name: "consumptionList",
                    component: () => import( /* webpackChunkName: "consumptionList" */ "../components/page/basicdata/performance/ConsumptionList.vue"),
                    meta: {
                        title: '消化',
                        keepAlive: false,
                    }
                },
                {
                    path: "/consumptionDetail",
                    name: "consumptionDetail",
                    component: () => import( /* webpackChunkName: "consumptionDetail" */ "../components/page/basicdata/performance/ConsumptionDetail.vue"),
                    meta: {
                        title: '消化详情',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/personPerformanceList",
                    name: "personPerformanceList",
                    component: () => import( /* webpackChunkName: "personPerformanceList" */ "../components/page/basicdata/performance/PersonPerformanceList.vue"),
                    meta: {
                        title: '人员绩效',
                        keepAlive: false,
                    }
                },
                {
                    path: "/personPerformanceDetail",
                    name: "personPerformanceDetail",
                    component: () => import( /* webpackChunkName: "personPerformanceDetail" */ "../components/page/basicdata/performance/PersonPerformanceDetail.vue"),
                    meta: {
                        title: '人员绩效详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/personPerformanceEdit",
                    name: "personPerformanceEdit",
                    component: () => import( /* webpackChunkName: "personPerformanceEdit" */ "../components/page/basicdata/performance/PersonPerformanceEdit.vue"),
                    meta: {
                        title: '人员绩效',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/personPerformanceConfirmList",
                    name: "personPerformanceConfirmList",
                    component: () => import( /* webpackChunkName: "personPerformanceConfirmList" */ "../components/page/basicdata/performance/PersonPerformanceConfirmList.vue"),
                    meta: {
                        title: '人员绩效审批',
                        keepAlive: false,
                    }
                },
                {
                    path: "/personPerformanceConfirmDetail",
                    name: "personPerformanceConfirmDetail",
                    component: () => import( /* webpackChunkName: "personPerformanceConfirmDetail" */ "../components/page/basicdata/performance/PersonPerformanceConfirmDetail.vue"),
                    meta: {
                        title: '人员绩效审批详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/personPerformanceConfirmEdit",
                    name: "personPerformanceConfirmEdit",
                    component: () => import( /* webpackChunkName: "personPerformanceConfirmEdit" */ "../components/page/basicdata/performance/PersonPerformanceConfirmEdit.vue"),
                    meta: {
                        title: '人员绩效审批',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/personPerformanceLineList",
                    name: "personPerformanceLineList",
                    component: () => import( /* webpackChunkName: "personPerformanceLineList" */ "../components/page/basicdata/performance/PersonPerformanceLineList.vue"),
                    meta: {
                        title: '人员绩效调整',
                        keepAlive: false,
                    }
                },
                {
                    path: "/personPerformanceLineDetail",
                    name: "personPerformanceLineDetail",
                    component: () => import( /* webpackChunkName: "personPerformanceLineDetail" */ "../components/page/basicdata/performance/PersonPerformanceLineDetail.vue"),
                    meta: {
                        title: '人员绩效调整详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/personPerformanceLineEdit",
                    name: "personPerformanceLineEdit",
                    component: () => import( /* webpackChunkName: "personPerformanceLineEdit" */ "../components/page/basicdata/performance/PersonPerformanceLineEdit.vue"),
                    meta: {
                        title: '人员绩效调整',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/performanceAttributionList",
                    name: "performanceAttributionList",
                    component: () => import( /* webpackChunkName: "performanceAttributionList" */ "../components/page/basicdata/performance/PerformanceAttributionList.vue"),
                    meta: {
                        title: '绩效归属',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performanceAttributionDetail",
                    name: "performanceAttributionDetail",
                    component: () => import( /* webpackChunkName: "performanceAttributionDetail" */ "../components/page/basicdata/performance/PerformanceAttributionDetail.vue"),
                    meta: {
                        title: '绩效归属详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/performanceAttributionEdit",
                    name: "performanceAttributionEdit",
                    component: () => import( /* webpackChunkName: "performanceAttributionEdit" */ "../components/page/basicdata/performance/PerformanceAttributionEdit.vue"),
                    meta: {
                        title: '绩效归属',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/businessUnitList",
                    name: "businessUnitList",
                    component: () => import( /* webpackChunkName: "businessUnitList" */ "../components/page/basicdata/performance/BusinessUnitList.vue"),
                    meta: {
                        title: '业务单元',
                        keepAlive: false,
                    }
                },
                {
                    path: "/businessUnitDetail",
                    name: "businessUnitDetail",
                    component: () => import( /* webpackChunkName: "businessUnitDetail" */ "../components/page/basicdata/performance/BusinessUnitDetail.vue"),
                    meta: {
                        title: '业务单元详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/businessUnitEdit",
                    name: "businessUnitEdit",
                    component: () => import( /* webpackChunkName: "businessUnitEdit" */ "../components/page/basicdata/performance/BusinessUnitEdit.vue"),
                    meta: {
                        title: '业务单元',
                        keepAlive: false,
                    }
                },
                //
                {
                    path: "/terminalAuthorizationList",
                    name: "terminalAuthorizationList",
                    component: () => import( /* webpackChunkName: "terminalAuthorizationList" */ "../components/page/basicdata/terminalAuthorization/TerminalAuthorizationList.vue"),
                    meta: {
                        title: '终端授权',
                        keepAlive: false,
                    }
                },
                {
                    path: "/terminalAuthorizationDetail",
                    name: "terminalAuthorizationDetail",
                    component: () => import( /* webpackChunkName: "terminalAuthorizationDetail" */ "../components/page/basicdata/terminalAuthorization/TerminalAuthorizationDetail.vue"),
                    meta: {
                        title: '终端授权详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/terminalAuthorizationEdit",
                    name: "terminalAuthorizationEdit",
                    component: () => import( /* webpackChunkName: "terminalAuthorizationEdit" */ "../components/page/basicdata/terminalAuthorization/TerminalAuthorizationEdit.vue"),
                    meta: {
                        title: '终端授权',
                        keepAlive: false,
                    }
                },
                {
                    path: "/accountParentList",
                    name: "accountParentList",
                    component: () => import( /* webpackChunkName: "accountParentList" */ "../components/page/basicdata/accountParent/AccountParentList.vue"),
                    meta: {
                        title: '上级审批',
                        keepAlive: false,
                    }
                },
                {
                    path: "/accountParentDetail",
                    name: "accountParentDetail",
                    component: () => import( /* webpackChunkName: "accountParentDetail" */ "../components/page/basicdata/accountParent/AccountParentDetail.vue"),
                    meta: {
                        title: '上级审批详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/accountParentEdit",
                    name: "accountParentEdit",
                    component: () => import( /* webpackChunkName: "accountParentEdit" */ "../components/page/basicdata/accountParent/AccountParentEdit.vue"),
                    meta: {
                        title: '上级审批',
                        keepAlive: false,
                    }
                },
                {
                    path: "/flowConfig01List",
                    name: "flowConfig01List",
                    component: () => import( /* webpackChunkName: "flowConfig01List" */ "../components/page/basicdata/flowConfig01/FlowConfig01List.vue"),
                    meta: {
                        title: '流向商业配置',
                        keepAlive: false,
                    }
                },
                {
                    path: "/flowConfig01Detail",
                    name: "flowConfig01Detail",
                    component: () => import( /* webpackChunkName: "flowConfig01Detail" */ "../components/page/basicdata/flowConfig01/FlowConfig01Detail.vue"),
                    meta: {
                        title: '流向商业配置详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/flowConfig01Edit",
                    name: "flowConfig01Edit",
                    component: () => import( /* webpackChunkName: "flowConfig01Edit" */ "../components/page/basicdata/flowConfig01/FlowConfig01Edit.vue"),
                    meta: {
                        title: '流向商业配置',
                        keepAlive: false,
                    }
                },
                {
                    path: "/flowConfig01FlowList",
                    name: "flowConfig01FlowList",
                    component: () => import( /* webpackChunkName: "flowConfig01FlowList" */ "../components/page/basicdata/flowConfig01/FlowConfig01FlowList.vue"),
                    meta: {
                        title: '批量设置',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerProductAccountList",
                    name: "partnerProductAccountList",
                    component: () => import( /* webpackChunkName: "partnerProductAccountList" */ "../components/page/basicdata/partnerProductAccount/PartnerProductAccountList.vue"),
                    meta: {
                        title: '合作产品路径',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerProductAccountDetail",
                    name: "partnerProductAccountDetail",
                    component: () => import( /* webpackChunkName: "partnerProductAccountDetail" */ "../components/page/basicdata/partnerProductAccount/PartnerProductAccountDetail.vue"),
                    meta: {
                        title: '合作产品路径详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerProductAccountEdit",
                    name: "partnerProductAccountEdit",
                    component: () => import( /* webpackChunkName: "partnerProductAccountEdit" */ "../components/page/basicdata/partnerProductAccount/PartnerProductAccountEdit.vue"),
                    meta: {
                        title: '合作产品路径',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerProductAccountPeriodList",
                    name: "partnerProductAccountPeriodList",
                    component: () => import( /* webpackChunkName: "partnerProductAccountPeriodList" */ "../components/page/basicdata/partnerProductAccountPeriod/PartnerProductAccountPeriodList.vue"),
                    meta: {
                        title: '合作产品路径期间',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerProductAccountPeriodDetail",
                    name: "partnerProductAccountPeriodDetail",
                    component: () => import( /* webpackChunkName: "partnerProductAccountPeriodDetail" */ "../components/page/basicdata/partnerProductAccountPeriod/partnerProductAccountPeriodDetail.vue"),
                    meta: {
                        title: '合作产品路径期间详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/partnerProductAccountPeriodEdit",
                    name: "partnerProductAccountPeriodEdit",
                    component: () => import( /* webpackChunkName: "partnerProductAccountPeriodEdit" */ "../components/page/basicdata/partnerProductAccountPeriod/partnerProductAccountPeriodEdit.vue"),
                    meta: {
                        title: '合作产品路径期间',
                        keepAlive: false,
                    }
                },
                {
                    path: "/commodityFlowStateInitDetail",
                    name: "commodityFlowStateInitDetail",
                    component: () => import( /* webpackChunkName: "commodityFlowStateInitDetail" */ "../components/page/basicdata/commodityFlowStateInit/CommodityFlowStateInitDetail.vue"),
                    meta: {
                        title: '合作产品路径初始化详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/commodityFlowStateInitEdit",
                    name: "commodityFlowStateInitEdit",
                    component: () => import( /* webpackChunkName: "commodityFlowStateInitEdit" */ "../components/page/basicdata/commodityFlowStateInit/CommodityFlowStateInitEdit.vue"),
                    meta: {
                        title: '合作产品路径初始化编辑',
                        keepAlive: false,
                    }
                },
                {
                    path: "/commodityFlowStateList",
                    name: "commodityFlowStateList",
                    component: () => import( /* webpackChunkName: "commodityFlowStateList" */ "../components/page/basicdata/commodityFlowState/CommodityFLowStateList.vue"),
                    meta: {
                        title: '流向状态',
                        keepAlive: false,
                    }
                },
                {
                    path: "/commodityFlowStateDetail",
                    name: "commodityFlowStateDetail",
                    component: () => import( /* webpackChunkName: "commodityFlowStateDetail" */ "../components/page/basicdata/commodityFlowState/CommodityFLowStateDetail.vue"),
                    meta: {
                        title: '流向状态详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/transactionConfigList",
                    name: "transactionConfigList",
                    component: () => import( /* webpackChunkName: "transactionConfigList" */ "../components/page/basicdata/transactionConfig/TransactionConfigList.vue"),
                    meta: {
                        title: '合作产品期间路径',
                        keepAlive: false,
                    }
                },
                {
                    path: "/transactionConfigDetail",
                    name: "transactionConfigDetail",
                    component: () => import( /* webpackChunkName: "transactionConfigDetail" */ "../components/page/basicdata/transactionConfig/TransactionConfigDetail.vue"),
                    meta: {
                        title: '合作产品期间路径详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/transactionConfigEdit",
                    name: "transactionConfigEdit",
                    component: () => import( /* webpackChunkName: "transactionConfigEdit" */ "../components/page/basicdata/transactionConfig/TransactionConfigEdit.vue"),
                    meta: {
                        title: '合作产品期间路径',
                        keepAlive: false,
                    }
                },
                {
                    path: "/transactionConfigDetailList",
                    name: "transactionConfigDetailList",
                    component: () => import( /* webpackChunkName: "transactionConfigDetailList" */ "../components/page/basicdata/transactionConfigDetail/TransactionConfigDetailList.vue"),
                    meta: {
                        title: '合作产品期间路径明细',
                        keepAlive: false,
                    }
                },
                {
                    path: "/transactionConfigDetailEdit",
                    name: "transactionConfigDetailEdit",
                    component: () => import( /* webpackChunkName: "transactionConfigDetailEdit" */ "../components/page/basicdata/transactionConfigDetail/TransactionConfigDetailEdit.vue"),
                    meta: {
                        title: '合作产品期间路径明细编辑',
                        keepAlive: false,
                    }
                },
                {
                    path: "/transactionFlowPendingList",
                    name: "transactionFlowPendingList",
                    component: () => import( /* webpackChunkName: "transactionFlowPendingList" */ "../components/page/basicdata/transactionFlowPending/TransactionFlowPendingList.vue"),
                    meta: {
                        title: '反匹配待处理',
                        keepAlive: false,
                    }
                },
                {
                    path: "/transactionFlowPendingDetail",
                    name: "transactionFlowPendingDetail",
                    component: () => import( /* webpackChunkName: "transactionFlowPendingDetail" */ "../components/page/basicdata/transactionFlowPending/TransactionFlowPendingDetail.vue"),
                    meta: {
                        title: '反匹配待处理详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/transactionFlowPendingEdit",
                    name: "transactionFlowPendingEdit",
                    component: () => import( /* webpackChunkName: "transactionFlowPendingEdit" */ "../components/page/basicdata/transactionFlowPending/TransactionFlowPendingEdit.vue"),
                    meta: {
                        title: '反匹配待处理',
                        keepAlive: false,
                    }
                },
                {
                    path: "/transactionFlowList",
                    name: "transactionFlowList",
                    component: () => import( /* webpackChunkName: "transactionFlowList" */ "../components/page/basicdata/transactionFlow/TransactionFlowList.vue"),
                    meta: {
                        title: '业务流向已匹配',
                        keepAlive: false,
                    }
                },
                {
                    path: "/personContractList",
                    name: "personContractList",
                    component: () => import( /* webpackChunkName: "personContractList" */ "../components/page/basicdata/personContract/PersonContractList.vue"),
                    meta: {
                        title: '合同',
                        keepAlive: false,
                    }
                },
                {
                    path: "/personContractDetail",
                    name: "personContractDetail",
                    component: () => import( /* webpackChunkName: "personContractDetail" */ "../components/page/basicdata/personContract/PersonContractDetail.vue"),
                    meta: {
                        title: '合同详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/personContractEdit",
                    name: "personContractEdit",
                    component: () => import( /* webpackChunkName: "personContractEdit" */ "../components/page/basicdata/personContract/PersonContractEdit.vue"),
                    meta: {
                        title: '合同',
                        keepAlive: false,
                    }
                },
                {
                    path: "/personExperienceList",
                    name: "personExperienceList",
                    component: () => import( /* webpackChunkName: "personExperienceList" */ "../components/page/basicdata/personExperience/PersonExperienceList.vue"),
                    meta: {
                        title: '经历',
                        keepAlive: false,
                    }
                },
                {
                    path: "/personExperienceDetail",
                    name: "personExperienceDetail",
                    component: () => import( /* webpackChunkName: "personExperienceDetail" */ "../components/page/basicdata/personExperience/PersonExperienceDetail.vue"),
                    meta: {
                        title: '经历详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/personExperienceEdit",
                    name: "personExperienceEdit",
                    component: () => import( /* webpackChunkName: "personExperienceEdit" */ "../components/page/basicdata/personExperience/PersonExperienceEdit.vue"),
                    meta: {
                        title: '经历',
                        keepAlive: false,
                    }
                },
                {
                    path: "/recycleList",
                    name: "recycleList",
                    component: () => import( /* webpackChunkName: "recycleList" */ "../components/page/recycle/RecycleList.vue"),
                    meta: {
                        title: '回收站',
                        keepAlive: false,
                    }
                },
                {
                    path: "/processList",
                    name: "processList",
                    component: () => import( /* webpackChunkName: "processList" */ "../components/page/processManage/processRules/ProcessList.vue"),
                    meta: {
                        title: '流程',
                        keepAlive: false,
                    }
                },
                {
                    path: "/processDetails",
                    name: "processDetails",
                    component: () => import( /* webpackChunkName: "processDetails" */ "../components/page/processManage/processRules/ProcessDetails.vue"),
                    meta: {
                        title: '流程详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/processLineList",
                    name: "processLineList",
                    component: () => import( /* webpackChunkName: "processLineList" */ "../components/page/processManage/processLine/ProcessLineList.vue"),
                    meta: {
                        title: '流程行',
                        keepAlive: false,
                    }
                },

                {
                    path: "/budgetAccountList",
                    name: "budgetAccountList",
                    component: () => import( /* webpackChunkName: "budgetAccountList" */ "../components/page/budget/budgetAccount/BudgetAccountList.vue"),
                    meta: {
                        title: '预算科目',
                        keepAlive: false,
                    }
                },
                {
                    path: "/budgetAccountDetails",
                    name: "budgetAccountDetails",
                    component: () => import( /* webpackChunkName: "budgetAccountDetails" */ "../components/page/budget/budgetAccount/BudgetAccountDetails.vue"),
                    meta: {
                        title: '预算科目详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/budgetAccountEdit",
                    name: "budgetAccountEdit",
                    component: () => import( /* webpackChunkName: "budgetAccountEdit" */ "../components/page/budget/budgetAccount/BudgetAccountEdit.vue"),
                    meta: {
                        title: '预算科目',
                        keepAlive: false,
                    }
                },
                {
                    path: "/budgetItemList",
                    name: "budgetItemList",
                    component: () => import( /* webpackChunkName: "budgetItemList" */ "../components/page/budget/budgetItem/BudgetItemList.vue"),
                    meta: {
                        title: '预算项目',
                        keepAlive: false,
                    }
                },
                {
                    path: "/budgetItemDetails",
                    name: "budgetItemDetails",
                    component: () => import( /* webpackChunkName: "budgetItemDetails" */ "../components/page/budget/budgetItem/BudgetItemDetails.vue"),
                    meta: {
                        title: '预算项目详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/budgetItemEdit",
                    name: "budgetItemEdit",
                    component: () => import( /* webpackChunkName: "budgetItemDetails" */ "../components/page/budget/budgetItem/BudgetItemEdit.vue"),
                    meta: {
                        title: '预算项目',
                        keepAlive: false,
                    }
                },
                {
                    path: "/budgetObjectList",
                    name: "budgetObjectList",
                    component: () => import( /* webpackChunkName: "budgetObjectList" */ "../components/page/budget/budgetObject/BudgetObjectList.vue"),
                    meta: {
                        title: '预算对象',
                        keepAlive: false,
                    }
                },
                {
                    path: "/budgetObjectDetails",
                    name: "budgetObjectDetails",
                    component: () => import( /* webpackChunkName: "budgetObjectDetails" */ "../components/page/budget/budgetObject/BudgetObjectDetails.vue"),
                    meta: {
                        title: '预算对象详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/budgetObjectEdit",
                    name: "budgetObjectEdit",
                    component: () => import( /* webpackChunkName: "budgetObjectEdit" */ "../components/page/budget/budgetObject/BudgetObjecEdit.vue"),
                    meta: {
                        title: '预算对象',
                        keepAlive: false,
                    }
                },
                {
                    path: "/budgetReportList",
                    name: "budgetReportList",
                    component: () => import( /* webpackChunkName: "budgetReportList" */ "../components/page/budget/budgetReport/BudgetReportList.vue"),
                    meta: {
                        title: '预算执行报告',
                        keepAlive: false,
                    }
                },
                {
                    path: "/budgetReportDetails",
                    name: "budgetReportDetails",
                    component: () => import( /* webpackChunkName: "budgetReportDetails" */ "../components/page/budget/budgetReport/BudgetReportDetails.vue"),
                    meta: {
                        title: '预算执行详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/budgetReportEdit",
                    name: "budgetReportEdit",
                    component: () => import( /* webpackChunkName: "budgetReportEdit" */ "../components/page/budget/budgetReport/BudgetReportEdit.vue"),
                    meta: {
                        title: '预算执行报告',
                        keepAlive: false,
                    }
                },
                {
                    path: "/budgetSourceList",
                    name: "budgetSourceList",
                    component: () => import( /* webpackChunkName: "budgetSourceList" */ "../components/page/budget/budgetSource/BudgetSourceList.vue"),
                    meta: {
                        title: '预算源组',
                        keepAlive: false,
                    }
                },
                {
                    path: "/budgetSourceDetail",
                    name: "budgetSourceDetail",
                    component: () => import( /* webpackChunkName: "budgetSourceDetail" */ "../components/page/budget/budgetSource/BudgetSourceDetail.vue"),
                    meta: {
                        title: '预算源组详情',
                        keepAlive: false,
                    }
                },
                {
                    path: "/budgetSourceEdit",
                    name: "budgetSourceEdit",
                    component: () => import( /* webpackChunkName: "budgetSourceEdit" */ "../components/page/budget/budgetSource/BudgetSourceEdit.vue"),
                    meta: {
                        title: '预算源组',
                        keepAlive: false,
                    }
                },
                {
                    path: "/budgetItemSourceDetail",
                    name: "budgetItemSourceDetail",
                    component: () => import( /* webpackChunkName: "budgetItemSourceDetail" */ "../components/page/budget/budgetSource/BudgetItemSourceDetail.vue"),
                    meta: {
                        title: '预算源详情',
                        keepAlive: false,
                    }
                },
            ]
        },
        {
            path: '/login',
            component: () => import( /* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: {
                title: '登录'
            }
        },
        {
            path: '/forget',
            component: () => import( /* webpackChunkName: "forget" */ '../components/page/Forget.vue'),
            meta: {
                title: '忘记密码'
            }
        },
        {
            path: "/k3Upload",
            name: "k3Upload",
            component: () => import( /* webpackChunkName: "k3Upload" */ "../components/page/basicdata/k3/K3Upload.vue"),
            meta: {
                title: '金蝶引入',
                keepAlive: false,
            }
        },
        {
            path: "/otherUpload",
            name: "OtherUpload",
            component: () => import( /* webpackChunkName: "otherUpload" */ "../components/page/basicdata/k3/OtherUpload.vue"),
            meta: {
                title: '导入Excel',
                keepAlive: false,
            }
        },
        {
            path: "/organization_pub",
            name: "organization_pub",
            component: () => import( /* webpackChunkName: "organizationPub" */ "../components/page/basicdata/Organization.vue"),
            meta: {
                title: '组织架构',
                keepAlive: false,
            }
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
    if (to.path === '/login' || to.path === '/forget' || to.path == '/k3Upload' || to.path == '/organization_pub' || to.path == '/otherUpload') {
        next();
    } else {
        let token = localStorage.getItem('adminToken');
        if (token === null || token === '') {
            next('/login');
        } else {
            next();
        }
    }
});
export default router;